export default __webpack_public_path__ + "static/media/notificheCommercialiNC.3fdbd915.svg";